import React from 'react';
import Icon from '../../atoms/Icon';
import './StatCard.css';

interface StatCardProps {
  title: string;
  value: string | number;
  change: string;
  changeType: 'positive' | 'negative' | 'neutral';
  icon: 'cart' | 'clock' | 'dollar' | 'cake';
  iconType: 'orders' | 'pending' | 'revenue' | 'products';
}

const StatCard: React.FC<StatCardProps> = ({ 
  title, 
  value, 
  change, 
  changeType, 
  icon, 
  iconType 
}) => {
  return (
    <div className="stat-card">
      <div className={`stat-icon ${iconType}`}>
        <Icon type={icon} size="medium" />
      </div>
      <div className="stat-content">
        <h3>{value}</h3>
        <p className="stat-title">{title}</p>
        <span className={`stat-change ${changeType}`}>{change}</span>
      </div>
    </div>
  );
};

export default StatCard;
